"use strict"

import React, {useState} from "react"
import {observer} from "mobx-react"
import MobxReactForm from "mobx-react-form"
import validatorjs from "validatorjs"
import dvr from "mobx-react-form/lib/validators/DVR"
import {injectIntl} from "react-intl"
import ReCAPTCHA from "react-google-recaptcha"
import config from "../../global/config/settings"

import {Grid, Paper, Typography, Link, Box} from "@material-ui/core"

import XsInput from "../../global/ui/xsInput/xsInput"
import XsButton from "../../global/ui/xsButton/xsButton"

import LoginStore from "./loginStore"
import GlobalStore from "../../global/store/GlobalStore"

function ForgotPassword() {
	const hooks = {
		onSubmit() {
			const {email} = form.values()

			if (isEmpty(email)) {
				GlobalStore.setNotificationMessage("Email je povinný!", "", "warning")
				form.invalidate()
			}
		},
		onSuccess(form) {
			LoginStore.handleResetPassword(form)
		},
		onError() {}
	}

	const [form] = useState(
		new MobxReactForm(
			{
				fields: {
					email: {label: "Prihlasovacie meno / email", rules: "email|string|required"}
				}
			},
			{plugins: {dvr: dvr(validatorjs)}, hooks}
		)
	)

	return (
		<Grid container direction="column" spacing={3}>
			<Grid item className="textCenter">
				<Typography variant="h3">Reset hesla</Typography>
			</Grid>
			<Grid item>
				<Paper variant="elevation" elevation={2} style={{backgroundColor: "transparent"}}>
					<Box p={2}>
						<Grid item container direction="column" spacing={3}>
							<Grid item container direction="column" spacing={1}>
								<Grid item>
									<Typography variant="subtitle2">Ako nastavíte/zmeníte Vaše heslo</Typography>
								</Grid>
								<Grid item>
									<Typography variant="body2">
										1. Zadajte e-mailovú adresu, ktorú ste použili pri registrácii.
									</Typography>
								</Grid>
								<Grid item>
									<Typography variant="body2">2. Stlačte tlačidlo “RESETOVAŤ HESLO”.</Typography>
								</Grid>
								<Grid item>
									<Typography variant="body2">
										3. Do Vašej schránky bude zaslaný email s odkazom, na ktorom si môžete nastaviť/zmeniť heslo.
									</Typography>
								</Grid>
							</Grid>
							<Grid item>
								<XsInput field={form.$("email")} autoFocus={true} submitAction={(e) => form.onSubmit(e)} />
							</Grid>
							<Grid item>
								<XsButton text="Resetovať heslo" onClick={form.onSubmit} />
							</Grid>
							{GlobalStore.enabledRecaptchaV2 && (
								<Grid item>
									<ReCAPTCHA
										sitekey={config.SITE_KEY_V2 || ""}
										onChange={(token) => {
											GlobalStore.tokenRecaptchaV2 = token
										}}
									/>
								</Grid>
							)}
							<Grid item>
								<Link
									variant="body2"
									className="pointer"
									onClick={() => (LoginStore.screen = LoginStore.screens.LOGIN)}
								>
									Späť na prihlásenie
								</Link>
							</Grid>
						</Grid>
					</Box>
				</Paper>
			</Grid>
		</Grid>
	)
}

export default injectIntl(observer(ForgotPassword))

